import { createReducer, on } from '@ngrx/store';
import {
  createPass,
  createPassFailure,
  createPassSuccess,
  forgotPass,
  forgotPassFailure,
  forgotPassSuccess,
  login,
  loginFailure,
  loginSuccess,
  logout,
  resetFlags,
  verifyOTP,
  verifyOTPFailure,
  verifyOTPSuccess,
} from './authentication.actions';
import type { User } from './auth.model';

export type AuthenticationState = {
  isLoggedIn: boolean;
  user: User | null;
  error: any | null;
  createPassMessage: string;
  isLoading: boolean;
  forgotPass: {
    success: boolean;
    message: string;
    error: any;
  } | null;
  verifyOTP: {
    success: boolean;
    message: string;
    error: any;
  } | null;
  forgotPassLoading: boolean;
  verifyOTPLoading: boolean;
  isLoggingIn: boolean;
};

const initialState: AuthenticationState = {
  isLoggedIn: false,
  user: null,
  error: null,
  createPassMessage: '',
  isLoading: false,
  forgotPass: null,
  verifyOTP: null,
  forgotPassLoading: false,
  verifyOTPLoading: false,
  isLoggingIn: false,
};

export const authenticationReducer = createReducer(
  initialState,
  on(login, (state) => ({ ...state, error: null, isLoggingIn: true })),
  on(loginSuccess, (state, { user }) => ({
    ...state,
    isLoggedIn: true,
    user,
    error: null,
    isLoggingIn: false,
  })),
  on(loginFailure, (state, { error }) => ({
    ...state,
    error,
    isLoggingIn: false,
  })),

  on(logout, (state) => ({ ...state, user: null, isLoggedIn: false })),
  on(createPass, (state) => ({ ...state, message: null, isLoading: true })),
  on(createPassSuccess, (state, data) => ({
    ...state,
    createPassMessage: data.message,
    isLoading: false,
  })),
  on(createPassFailure, (state, data) => ({
    ...state,
    createPassMessage: data.message,
    isLoading: false,
  })),
  on(resetFlags, (state) => {
    return {
      ...state,
      forgotPass: null,
      createPassMessage: '',
      verifyOTP: null,
    };
  }),
  on(forgotPass, (state) => ({
    ...state,
    message: null,
    isLoading: true,
    forgotPass: null,
    forgotPassLoading: true,
  })),
  on(forgotPassSuccess, (state, { message, success }) => ({
    ...state,
    forgotPass: { message, success, error: null },
    isLoading: false,
    forgotPassLoading: false,
  })),
  on(forgotPassFailure, (state, data) => ({
    ...state,
    forgotPass: data,
    isLoading: false,
    forgotPassLoading: false,
  })),

  on(verifyOTP, (state) => ({
    ...state,
    message: null,
    isLoading: true,
    verifyOTP: null,
    verifyOTPLoading: true,
  })),
  on(verifyOTPSuccess, (state, { message, success }) => ({
    ...state,
    verifyOTP: { message, success, error: null },
    isLoading: false,
    verifyOTPLoading: false,
  })),
  on(verifyOTPFailure, (state, data) => ({
    ...state,
    verifyOTP: data,
    isLoading: false,
    verifyOTPLoading: false,
  }))
);
